import styled from '@emotion/styled';

export const StyledLogo = styled.img`
  width: 100%;
`;
